import React, { useState } from 'react';
import 'tailwindcss/tailwind.css';
//import logoFull from "../../images/logoAnimado.gif";
import "../../../../App.css";
//import { resetPassword } from '../http/Actions/AuthAction'; // Asumiendo que existe esta función
import { requestPasswordReset, verifyResetCode, resetPassword } from '../../../http/Actions/AuthAction';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [resetCode, setResetCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [step, setStep] = useState(1); // 1: Email, 2: Código, 3: Nueva contraseña, 4: Éxito
  const [error, setError] = useState(null);
  const [passwordError, setPasswordError] = useState('');
  const [passwordMatchError, setPasswordMatchError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await requestPasswordReset(email);
      setIsLoading(false);
      setStep(2);
    } catch (error) {
      setIsLoading(false);
      setError('No pudimos enviar un código a ese email. Por favor, verifique que sea correcto.');
    }
  };

  const handleCodeSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await verifyResetCode(email, resetCode);
      setIsLoading(false);
      setStep(3);
    } catch (error) {
      setIsLoading(false);
      setError('El código ingresado no es válido. Inténtalo nuevamente.');
    }
  };

  const checkPasswordStrength = (password) => {
    const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (!strongPasswordRegex.test(password)) {
      setPasswordError('La contraseña debe tener al menos 8 caracteres, incluyendo una mayúscula, una minúscula, un número y un carácter especial.');
      return false;
    } else {
      setPasswordError('');
      return true;
    }
  };

  const checkPasswordMatch = (confirmPass) => {
    if (confirmPass !== newPassword) {
      setPasswordMatchError('Las contraseñas no coinciden.');
      return false;
    } else {
      setPasswordMatchError('');
      return true;
    }
  };

  const handleNewPasswordSubmit = async (e) => {
    e.preventDefault();
    
    const isPasswordStrong = checkPasswordStrength(newPassword);
    const doPasswordsMatch = checkPasswordMatch(confirmPassword);
    
    if (!isPasswordStrong || !doPasswordsMatch) {
      return;
    }
    
    setIsLoading(true);
    try {
      await resetPassword({
        email: email,
        resetCode: resetCode,
        newPassword: newPassword
      });
      setIsLoading(false);
      setStep(4);
    } catch (error) {
      setIsLoading(false);
      setError('No pudimos cambiar tu contraseña. Por favor, inténtalo más tarde.');
    }
  };

  return (
    <div 
    className="min-h-screen flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-black relative"
    style={{
      backgroundImage: 'url(https://i.postimg.cc/rw3XpzPP/wallpaper.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    }}
  >
    {/* Cambia el overlay para asegurar que cubra toda la página */}
    <div className="absolute top-0 left-0 right-0 bottom-0 w-full h-full bg-black bg-opacity-50"></div>
      
      <div className="z-10 max-w-md w-full">
        <div className="text-center mb-8">
          <h2 className="mt-6 text-4xl font-extrabold text-white">
            Recupera tu acceso
          </h2>
          <p className="mt-2 text-sm text-gray-300">
            {step === 1 && "Te enviaremos un código para restablecer tu contraseña"}
            {step === 2 && "Ingresa el código que enviamos a tu correo"}
            {step === 3 && "Crea una nueva contraseña segura"}
            {step === 4 && "¡Listo! Ya puedes volver a reírte con nosotros"}
          </p>
        </div>
        
        <div className="bg-zinc-900 rounded-2xl shadow-xl overflow-hidden">
          {step === 1 && (
            <form className="p-8" onSubmit={handleEmailSubmit}>
              {error && (
                <div className="bg-red-500/20 border border-red-500 text-red-100 px-4 py-3 rounded mb-6">
                  <p className="text-sm">{error}</p>
                </div>
              )}
              
              <div className="mb-6">
                <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-1">
                  Email
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="appearance-none block w-full px-3 py-3 border border-zinc-700 rounded-lg 
                           bg-zinc-800 text-white placeholder-gray-500 focus:outline-none focus:ring-2 
                           focus:ring-red-500 focus:border-transparent"
                  placeholder="tu@email.com"
                />
              </div>

              <button
                type="submit"
                disabled={isLoading}
                className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg
                        text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 
                        focus:ring-red-500 font-bold transition duration-300 disabled:opacity-50"
              >
                {isLoading ? (
                  <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                ) : (
                  "Enviar código de recuperación"
                )}
              </button>
            </form>
          )}

          {step === 2 && (
            <form className="p-8" onSubmit={handleCodeSubmit}>
              {error && (
                <div className="bg-red-500/20 border border-red-500 text-red-100 px-4 py-3 rounded mb-6">
                  <p className="text-sm">{error}</p>
                </div>
              )}
              
              <div className="mb-6">
                <label htmlFor="resetCode" className="block text-sm font-medium text-gray-300 mb-1">
                  Código de recuperación
                </label>
                <input
                  id="resetCode"
                  name="resetCode"
                  type="text"
                  required
                  value={resetCode}
                  onChange={(e) => setResetCode(e.target.value)}
                  className="appearance-none block w-full px-3 py-3 border border-zinc-700 rounded-lg 
                           bg-zinc-800 text-white placeholder-gray-500 focus:outline-none focus:ring-2 
                           focus:ring-red-500 focus:border-transparent"
                  placeholder="Ingresa el código de 6 dígitos"
                />
                <p className="mt-2 text-sm text-gray-400">
                  Revisa tu bandeja de entrada (y la carpeta de spam) para encontrar el código que te enviamos.
                </p>
              </div>

              <div className="flex items-center justify-between">
                <button
                  type="button"
                  onClick={() => setStep(1)}
                  className="text-red-400 hover:text-red-300 text-sm"
                >
                  Volver atrás
                </button>
                
                <button
                  type="submit"
                  disabled={isLoading}
                  className="flex justify-center py-3 px-6 border border-transparent rounded-lg
                          text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 
                          focus:ring-red-500 font-bold transition duration-300 disabled:opacity-50"
                >
                  {isLoading ? (
                    <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                  ) : (
                    "Verificar código"
                  )}
                </button>
              </div>
            </form>
          )}

          {step === 3 && (
            <form className="p-8" onSubmit={handleNewPasswordSubmit}>
              {error && (
                <div className="bg-red-500/20 border border-red-500 text-red-100 px-4 py-3 rounded mb-6">
                  <p className="text-sm">{error}</p>
                </div>
              )}
              
              <div className="mb-4">
                <label htmlFor="newPassword" className="block text-sm font-medium text-gray-300 mb-1">
                  Nueva contraseña
                </label>
                <input
                  id="newPassword"
                  name="newPassword"
                  type="password"
                  required
                  value={newPassword}
                  onChange={(e) => {
                    setNewPassword(e.target.value);
                    checkPasswordStrength(e.target.value);
                  }}
                  className="appearance-none block w-full px-3 py-3 border border-zinc-700 rounded-lg 
                           bg-zinc-800 text-white placeholder-gray-500 focus:outline-none focus:ring-2 
                           focus:ring-red-500 focus:border-transparent"
                  placeholder="••••••••••••"
                />
                {passwordError && <p className="mt-1 text-sm text-red-400">{passwordError}</p>}
              </div>
              
              <div className="mb-6">
                <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-300 mb-1">
                  Confirmar contraseña
                </label>
                <input
                  id="confirmPassword"
                  name="confirmPassword"
                  type="password"
                  required
                  value={confirmPassword}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                    checkPasswordMatch(e.target.value);
                  }}
                  className="appearance-none block w-full px-3 py-3 border border-zinc-700 rounded-lg 
                           bg-zinc-800 text-white placeholder-gray-500 focus:outline-none focus:ring-2 
                           focus:ring-red-500 focus:border-transparent"
                  placeholder="••••••••••••"
                />
                {passwordMatchError && <p className="mt-1 text-sm text-red-400">{passwordMatchError}</p>}
              </div>

              <div className="flex items-center justify-between">
                <button
                  type="button"
                  onClick={() => setStep(2)}
                  className="text-red-400 hover:text-red-300 text-sm"
                >
                  Volver atrás
                </button>
                
                <button
                  type="submit"
                  disabled={isLoading}
                  className="flex justify-center py-3 px-6 border border-transparent rounded-lg
                          text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 
                          focus:ring-red-500 font-bold transition duration-300 disabled:opacity-50"
                >
                  {isLoading ? (
                    <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                  ) : (
                    "Cambiar contraseña"
                  )}
                </button>
              </div>
            </form>
          )}

          {step === 4 && (
            <div className="p-8 text-center">
              <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
                <svg className="h-10 w-10 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              
              <h3 className="text-xl font-bold text-white mb-2">¡Contraseña cambiada con éxito!</h3>
              <p className="text-gray-400 mb-6">
                Ya puedes iniciar sesión con tu nueva contraseña y volver a disfrutar de los mejores shows de comedia.
              </p>
              
              
                <a href="/login"
                className="inline-block w-full py-3 px-4 border border-transparent rounded-lg
                        text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 
                        focus:ring-red-500 font-bold transition duration-300"
              >
                Ir a iniciar sesión
              </a>
            </div>
          )}
          
          <div className="px-8 py-6 bg-zinc-950 text-center">
            <p className="text-gray-300">
              ¿Recuerdas tu contraseña? <a href="/login" className="text-red-400 hover:underline font-bold">Iniciar sesión</a>
            </p>
            <p className="text-xs text-gray-500 mt-4">
              Si sigues teniendo problemas, contacta a nuestro equipo de soporte y te ayudaremos a recuperar tu acceso más rápido que un chiste improvisado.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;